import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { sections: Array }

  copy() {
    const markdown = this.sectionsValue
      .map(({ title, content }) => {
        const body = content != null ? JSON.stringify(content, null, 2) : ""
        return `## ${title}\n\n\`\`\`json\n${body}\n\`\`\``
      })
      .join("\n\n")

    navigator.clipboard.writeText(markdown).then(() => {
      const original = this.element.innerHTML
      this.element.innerHTML = "Copied!"
      setTimeout(() => { this.element.innerHTML = original }, 2000)
    })
  }
}
